{
    "nav__new_offer": "Neues Angebot",
    "nav__continue_as_order": "Als Auftrag bearbeiten",

    "footer_button__next": "Weiter",
    "footer_button__back": "Zurück",
    "footer_button__save": "Entwurf speichern",
    "footer_button__cancel": "Abbrechen",
    "footer_button__finalize": "Abschließen",
    "footer_button__view_detail": "Mehr sehen",

    "stepper__step_1": "Kopfzeile",
    "stepper__step_2": "Einzelpositionen",
    "stepper__step_3": "Überprüfung"
}
